import { useEffect, type FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useSettings from 'hooks/useSettings';
import VersionDisplayer from 'components/shared/VersionDisplayer';
import MetbusLogo from '../../components/MetbusLogo';
import { THEMES } from '../../constants';
import useHelmet from 'src/hooks/useHelmet';
import useAuth from 'src/hooks/useAuth';
import { LoginType } from 'src/types/loginData';
import CardLogin from 'src/pages/authentication/components/login/CardLogin';
import LoginContainer from 'src/pages/authentication/components/LoginContainer';

const Login: FC = () => {
  const { settings } = useSettings();
  const { setLoginType } = useAuth();

  let contrastColor = false;
  if (settings.theme === THEMES.METBUSLIGHT) {
    contrastColor = true;
  }

  useEffect(() => {
    setLoginType(LoginType.NORMAL);
  }, []);

  useHelmet('Inicio de Sesión | Metbus');
  return (
    <LoginContainer>
      <Stack
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 5,
          '@media screen and (max-width: 770px)': {
            flexDirection: 'column',
          },
        }}
      >
        <MetbusLogo
          width="250"
          contrastColor={contrastColor}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <CardLogin
            onlyDtDomain={false}
            titleComponent={
              <Typography
                color="textPrimary"
                variant="h4"
              >
                Inicio de Sesión
              </Typography>
            }
          >
            <Typography
              component={RouterLink}
              to="/loginInspector"
              color="textPrimary"
              sx={(theme) => ({
                fontSize: '0.875rem',
                textDecoration: 'none',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginLeft: 'auto',
                // transition: 'all 0.3s ease',
                cursor: 'pointer',
                '&:hover': {
                  color: theme.palette.primary.main,
                },
              })}
            >
              Acceso Dirección del Trabajo
            </Typography>
          </CardLogin>
          <VersionDisplayer horizontal />
        </Box>
      </Stack>
    </LoginContainer>
  );
};

export default Login;
